export const select2Search = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: 0
}